





























import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';

export default defineComponent({
  name: 'UCIrvineChem1LCELN1OISafety1',
  components: {FileUploadUiComponent, STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        safety2Answer: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Safety Moment:',
          inputName: 'safety2Answer',
        },
      ],
    };
  },
});
